import React, { memo } from 'react';
import PropTypes from 'prop-types';
import TermsOfUseTop from 'components/Terms/TermsOfUseTop';
import TermsOfUseMain from 'components/Terms/TermsOfUseMain';
import DocumentsScreen from './DocumentsScreen';

const menuSections = [
  {
    id: 'scopeAndApplication',
    text: 'Scope and Application',
  },
  {
    id: 'restrictionsOnUse',
    text: 'Restrictions on Use',
  },
  {
    id: 'representations',
    text: 'Representations',
  },
  {
    id: 'yourJliveAccount',
    text: 'Your JLIVE Account',
  },
  {
    id: 'submittingInformation',
    text: 'Submitting Information',
  },
  {
    id: 'transfersAndRefunds',
    text: 'Transfers and Refunds',
  },
  {
    id: 'ownership',
    text: 'Ownership',
  },
  {
    id: 'software',
    text: 'Software',
  },
  {
    id: 'hyperlinks',
    text: 'Hyperlinks and Third Party Sites',
  },
  {
    id: 'disclaimerOfWarranty',
    text: 'Disclaimer of Warranty',
  },
  {
    id: 'indemnification',
    text: 'Indemnification',
  },
  {
    id: 'termAndTermination',
    text: 'Term and Termination',
  },
  {
    id: 'general',
    text: 'General',
  },
];

function TermsAndConditionsScreen({ inModal, onNavigate }) {
  const sections = menuSections.map((item) => ({
    id: item.id,
    text: item.text,
  }));

  const getTop = () => <TermsOfUseTop />;

  return (
    <DocumentsScreen
      title="Terms and Conditions"
      top={getTop()}
      sections={sections}
      inModal={inModal}
      onNavigate={onNavigate}
    >
      <TermsOfUseMain />
    </DocumentsScreen>
  );
}

TermsAndConditionsScreen.propTypes = {
  inModal: PropTypes.bool,
  onNavigate: PropTypes.func,
};

TermsAndConditionsScreen.defaultProps = {
  inModal: false,
  onNavigate: undefined,
};

export default memo(TermsAndConditionsScreen);
